<template>
  <div class="tooltip" @click="toggleTooltip">
    <slot></slot>
    <div
      v-if="isOpen"
      :class="['tooltip-content-wrapper', customClass, { show: isOpen }]"
      ref="tooltipElementRef"
      @click.stop
      aria-modal="true"
      role="dialog"
      :aria-hidden="!isOpen"
    >
      <slot name="tooltipContent"></slot>
    </div>
  </div>
</template>

<script setup>
  import { ref, onMounted, onUnmounted, watch, toRefs, defineEmits } from 'vue';

  const props = defineProps({
    text: {
      type: String,
      default: '',
    },
    customClass: {
      type: String,
      default: 'bottom',
    },
    modelValue: {
      // not compulsory to pass this as this can be used as extra if want to close modal from parent
      type: Boolean,
      default: false,
    },
  });

  const { modelValue } = toRefs(props);

  const isOpen = ref(false);
  const tooltipElementRef = ref(null);

  const emit = defineEmits(['update:modelValue']);

  const toggleTooltip = () => {
    isOpen.value = !isOpen.value;
    emit('update:modelValue', isOpen.value);
  };

  const handleClickOutside = (event) => {
    if (isOpen.value && !tooltipElementRef.value?.contains(event.target) && !event.target.closest('.tooltip')) {
      isOpen.value = false;
      emit('update:modelValue', false);
    }
  };

  onMounted(() => {
    document.addEventListener('click', handleClickOutside);
  });

  onUnmounted(() => {
    document.removeEventListener('click', handleClickOutside);
  });

  watch(modelValue, (newVal) => {
    isOpen.value = newVal;
  });
</script>
